import { createAction, props } from '@ngrx/store';
import { IBusinessDetailsResponse, IBusinessGroupNamesResponse } from '../models/shared.model';

export const getBusiness = createAction('[Shared] Load GetBusiness', props<{ businessId: string }>());

export const getBusinessSuccess = createAction(
  '[Shared] Load GetBusiness Success',
  props<{ response: IBusinessDetailsResponse[] }>()
);

export const getBusinessFailure = createAction('[Shared] Load GetBusiness Failure', props<{ error: Error | any }>());

export const loadLegalEntities = createAction(
  '[Shared] Load Legal Entities',
  props<{ param: string, noLoader: boolean }>()
);

export const loadLegalEntitiesSuccess = createAction(
  '[Shared] Load Legal Entities Success',
  props<{ response: [] }>()
);

export const loadLegalEntitiesFailure = createAction(
  '[Shared] Load Legal Entities Failure',
  props<{ error: any }>()
);


export const loadBusinessGroupNames = createAction('[BusinessGroupName] Load BusinessGroupNames', props<{ businessId: string }>());

export const loadBusinessGroupNamesSuccess = createAction(
  '[BusinessGroupName] Load BusinessGroupNames Success',
  props<{ response: IBusinessGroupNamesResponse[] }>()
);

export const loadBusinessGroupNamesFailure = createAction(
  '[BusinessGroupName] Load BusinessGroupNames Failure',
  props<{ error: Error | any }>()
);
